// Icons.jsx
// Kumpulan ikon SVG reusable untuk aplikasi

export const EyeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      fill="#4C4C4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.32341 11.4467C2.81066 6.97571 7.02791 3.75 12.0005 3.75C16.9708 3.75 21.1864 6.97271 22.6755 11.4405C22.7959 11.8015 22.796 12.1922 22.6759 12.5533C21.1886 17.0243 16.9714 20.25 11.9988 20.25C7.02847 20.25 2.81284 17.0273 1.32374 12.5595C1.2034 12.1985 1.20328 11.8078 1.32341 11.4467ZM17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.1005 17.25 6.75 14.8995 6.75 12C6.75 9.1005 9.1005 6.75 12 6.75C14.8995 6.75 17.25 9.1005 17.25 12Z"
      fill="#4C4C4D"
    />
  </svg>
);

export const SignUpArrow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00005 19L19 5.99996M19 5.99996V18.48M19 5.99996H6.52005"
      stroke="#262626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoogleIcon = () => (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_271)">
      <path
        d="M29.7073 15.8453C29.7073 14.8257 29.6247 13.8005 29.4483 12.7974H15.2998V18.5736H23.402C23.0658 20.4365 21.9855 22.0845 20.4036 23.1317V26.8797H25.2374C28.0759 24.2671 29.7073 20.409 29.7073 15.8453Z"
        fill="#4285F4"
      />
      <path
        d="M15.2999 30.5012C19.3454 30.5012 22.7572 29.1728 25.2429 26.88L20.4092 23.1321C19.0644 24.047 17.3282 24.5651 15.3054 24.5651C11.3921 24.5651 8.07409 21.925 6.88357 18.3755H1.89551V22.2392C4.4419 27.3044 9.62838 30.5012 15.2999 30.5012V30.5012Z"
        fill="#34A853"
      />
      <path
        d="M6.87798 18.3754C6.24965 16.5124 6.24965 14.4952 6.87798 12.6322V8.76855H1.89543C-0.232071 13.007 -0.232071 18.0006 1.89543 22.2391L6.87798 18.3754V18.3754Z"
        fill="#FBBC04"
      />
      <path
        d="M15.2999 6.43708C17.4384 6.40401 19.5053 7.20871 21.0541 8.68583L25.3366 4.40327C22.6249 1.85688 19.0258 0.456918 15.2999 0.501011C9.62838 0.501011 4.4419 3.69778 1.89551 8.76851L6.87805 12.6322C8.06306 9.07716 11.3866 6.43708 15.2999 6.43708V6.43708Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_271">
        <rect width="30" height="30" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
